import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import Spinner from "../presentationals/Spinner";
import { roundToTwo, timeStampFormat } from "../../utils/common/index";
import { triggerDashboardAudit } from "../../redux/actions";
import { useSelector } from "react-redux";

export default function CustomCard(props) {
  const { filterValue } = useSelector((state) => state.homeReducer);

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: props.dashboardName,
        empId: filterValue?.agentId?.length
          ? filterValue?.agentId
          : filterValue?.orgId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: props.viewName,
      },
    };
    triggerDashboardAudit(obj);
  };

  function csvHandler(e) {
    e.preventDefault();
    sendAudit();
    props.csvDownload(props.csvName);
  }
  return (
    <>
      <div className="col-md-4">
        <div
          className={`grad${props.gradient} whiteoverlaycir `}
          data-cy="custom-card"
        >
          <div
            className={`leftdiv ${
              props.percentage ? "col-7" : "col-10"
            } m-0 p-0`}
          >
            {props.cardTitle ? (
              <div className="subtitlebox">
                <p>{props.cardTitle}</p>
              </div>
            ) : (
              <div className="icon">
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/images/icons/paper.svg"
                  }
                  alt="billed"
                />
              </div>
            )}
            {/* <div className="icon"><img src={process.env.PUBLIC_URL+"/assets/images/icons/paper.svg"} alt="billed"/></div> */}
            <div className="titletxt">
              <p className="fw-bold">{props.tileName}</p>
              <span>
                {props.value !== "null" ? roundToTwo(props.value) : 0}
              </span>
            </div>
            {props.lmtd && (
              <div className="subtitle">
                <span className="text-dark fw-bold">
                  LMTD : {props.lmtd !== "null" ? roundToTwo(props.lmtd) : 0}
                </span>
              </div>
            )}
          </div>
          <div className={`rightdiv ${props.percentage ? "col-5" : "col-2"}`}>
            {props.csvDownload && (
              <div className="dowloaddiv float-right mr-3 mr-sm-0">
                {props.loading && props.loading[props.csvName] ? (
                  <Spinner showAlert={false} />
                ) : (
                  <span className="downloadarrow">
                    <button
                      type="button"
                      data-cy={props?.tileName?.replace(/ /g, "-")}
                      className="btn btn-link btn-sm m-0 p-0"
                      onClick={csvHandler}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/images/icons/download-arrow-w.svg"
                        }
                        alt="download"
                      />
                    </button>
                  </span>
                )}
              </div>
            )}
            <div className={`mdnchart ${props.percentage ? "" : "invisible"}`}>
              <div className="graph-div">
                <CircularProgressbarWithChildren
                  value={props.value}
                  text={`${props.value} %`}
                  background
                  styles={buildStyles({
                    textColor: "#000",
                    textSize: "18px",
                    trailColor: "#d6d6d6",
                    backgroundColor: "#fff",
                    pathColor: "#7b6ff4",
                  })}
                />
                {/* <CircularProgressbar value={props.value} text={`${props.value}%`} /> */}
                {/* <span className="progress-left"> <span className="progress-bar"></span> </span> <span className="progress-right"> <span className="progress-bar"></span> </span>
                            <div className="progress-value">{props.value}%</div> */}
              </div>
            </div>
            <div className="dowloaddiv"></div>
          </div>
        </div>
        {props.timestamp ? (
          <div
            className="card-timestamp border-top mt-2"
            data-cy="card-timestamp"
          >
            <i className="fa fa-history mr-2 mt-2 mb-0"></i>Updated on{" "}
            {timeStampFormat(props.timestamp.tileTimestamp)}
          </div>
        ) : null}
      </div>
    </>
  );
}
